// src/config/masterData.js

export const STATIC_MASTERS = {

    "ledger-group-nature": [
        { value: 1, label: "Asset" }, //Customer
        { value: 2, label: "Liability" }, //Vendors
        { value: 3, label: "Income" }, // Sale
        { value: 4, label: "Expense" }, // Purchase
    ],


    "billing-type": [
        { value: 1, label: "Goods" },
        { value: 2, label: "Services"}
    ],

    "business-type": [
        { value: 1, label: "Partnership" },
        { value: 2, label: "Sole proprietorship" },
        { value: 3, label: "Private Limited" },
        { value: 4, label: "Limited" },
        { value: 5, label: "Government" }
    ],

    "calendar-type": [
        { value: 1, label: "Task" },
        { value: 2, label: "Reminder" },
        { value: 3, label: "Marketing Lead" },
    ],


    "lead-status": [
        { value: 1, label: "New"},
        { value: 2, label: "Follow Up"},
        { value: 3, label: "In Progress"},
        { value: 4, label: "Demo"},
        { value: 5, label: "Negotiation"},
        { value: 6, label: "Closed"},
        { value: 7, label: "Lost"}
    ],

    /*
    "document-status": [
        { value: 1, label: "Open"},
        { value: 2, label: "In Progress"},
        { value: 3, label: "Closed"},
        { value: 4, label: "Reopen"},
        { value: 5, label: "Self Cancelled"},
        { value: 6,label: "On Hold"}
    ],
    */

    "expense-type": [
        { value: 1, label: "Direct" },
        { value: 2, label: "Indirect Expense" }
    ],

    "gender": [
        { value: 1, label: "Male" },
        { value: 2, label: "Female" },
        { value: 3, label: "Other" }
    ],

    "grievance-status": [
        { value: 1, label: "Open"},
        { value: 2, label: "In Progress"},
        { value: 3, label: "Closed"},
        { value: 4, label: "Reopen"},
        { value: 5, label: "Self Cancelled"},
        { value: 6,label: "On Hold"}
    ],


    "po-status":[
        {  value: 1,  label: "Order Placed"},
        {  value: 2,  label: "Order Received"},
        {  value: 3,  label: "In Progress"},
        {  value: 4,  label: "Shipped"},
        {  value: 5,  label: "Canceled By Vendor"},
        {  value: 6,  label: "Delivered"},
        {  value: 7,  label: "Canceled By Us"},
        {  value: 8,  label: "Closed"}
    ],

    "priority":[
        {  value: 1,  label: "High"},
        {  value: 2,  label: "Medium"},
        {  value: 3,  label: "Low"},
    ],
    
    "inventory-type": [
        { value: 1, label: "Finished" },
        { value: 2, label: "Raw" },
        { value: 3, label: "Consumable" }
    ],

    "inventory-transaction-type": [
        /* --- PURCHASE & SALE --- */
        { "value": 1, impact:"+", "label": "Purchase Inward", "detail": "+ Inventory coming in via Purchase Voucher." },
        { "value": 2, impact:"-", "label": "Bill/Outward", "detail": "- Inventory going out via Sale Voucher." },
        { "value": 3, impact:"+", "label": "Sale Cancel", "detail": "+ Restocked / Removed From Invoice." },
        { "value": 4, impact:"-", "label": "Purchase Cancel", "detail": "- Removed From Stock / Returned to Vendor." },

        /* --- TRANSFERS --- */
        { "value": 5, impact:"+", "label": "Transfer In", "detail": "Internal move: arriving at destination." },
        { "value": 6, impact:"-", "label": "Transfer Out", "detail": "Internal move: leaving source." },
        { "value": 7, impact:"+", "label": "Transfer Out Cancel", "detail": "Reversing Outward Transfer (Back to Source)." },
        { "value": 8, impact:"-", "label": "Transfer In Cancel", "detail": "Reversing Inward Transfer (Removed from Dest)." },

        /* --- CHALLANS --- */
        { "value": 9,  impact:"+", "label": "Challan In / GRN", "detail": "Goods received via Receipt Challan." },
        { "value": 10, impact:"-", "label": "Challan Out / Delivery Challan", "detail": "Goods sent out via Delivery Challan." },
        { "value": 11, impact:"+", "label": "Challan Out / Delivery Challan Cancel", "detail": "Reversing Delivery Challan (Stock back in)." },
        { "value": 12, impact:"-", "label": "Challan In / GRN Cancel", "detail": "Reversing Receipt Challan (Stock back out)." },

        /* --- ADJUSTMENTS --- */
        { "value": 13, impact:"+", "label": "Stock Adjustment Add", "detail": "Manual audit: Inventory found." },
        { "value": 14, impact:"-", "label": "Stock Adjustment Remove", "detail": "Manual audit: Wastage/Damage/Theft." },
        { "value": 15, impact:"+", "label": "Stock Adjustment Remove Cancel", "detail": "Reversing a removal (Stock back in)." },
        { "value": 16, impact:"-", "label": "Stock Adjustment Add Cancel", "detail": "Reversing an addition (Stock back out)." },


        /* --- RETURNS & RETURN CANCELLATIONS (Credit/Debit Notes) --- */
        { "value": 17, "impact": "+", "label": "Sales Return", "detail": "+ Stock arriving back from Customer via Credit Note." },
        { "value": 18, "impact": "-", "label": "Purchase Return", "detail": "- Stock being sent back to Vendor via Debit Note." },
        { "value": 19, "impact": "+", "label": "Purchase Return Cancel", "detail": "+ Reversing a Debit Note (Stock restored to warehouse)." },
        { "value": 20, "impact": "-", "label": "Sales Return Cancel", "detail": "- Reversing a Credit Note (Stock removed from warehouse)." }
    ],

    "registration-type": [
        { value: 1, label: "NA" },
        { value: 2, label: "Regular" },
        { value: 3, label: "Composition" },
        { value: 4, label: "Unregistered" },
        { value: 5, label: "Consumer" },
    ],

    "transaction-method": [
        { value: 1, label: "UPI" },
        { value: 2, label: "Crad" },
        { value: 3, label: "Cash" },
        { value: 4, label: "Cheque" },
        { value: 5, label: "NEFT" },
        { value: 6, label: "IMPS" }
    ],
    

    "indian-state" :[
        {value:1, label:"Jammu and Kashmir"},
        {value:2, label:"Himachal Pradesh"},
        {value:3, label:"Punjab"},
        {value:4, label:"Chandigarh"},
        {value:5, label:"Uttarakhand"},
        {value:6, label:"Haryana"},
        {value:7, label:"Delhi"},
        {value:8, label:"Rajasthan"},
        {value:9, label:"Uttar Pradesh"},
        {value:10, label:"Bihar"},
        {value:11, label:"Sikkim"},
        {value:12, label:"Arunachal Pradesh"},
        {value:13, label:"Nagaland"},
        {value:14, label:"Manipur"},
        {value:15, label:"Mizoram"},
        {value:16, label:"Tripura"},
        {value:17, label:"Meghalaya"},
        {value:18, label:"Assam"},
        {value:19, label:"West Bengal"},
        {value:20, label:"Jharkhand"},
        {value:21, label:"Odisha"},
        {value:22, label:"Chhattisgarh"},
        {value:23, label:"Madhya Pradesh"},
        {value:24, label:"Gujarat"},
        {value:25, label:"Dadra and Nagar Haveli and Daman and Diu"},
        {value:26, label:"Dadra and Nagar Haveli and Daman and Diu (Legacy)"},
        {value:27, label:"Maharashtra"},
        {value:29, label:"Karnataka"},
        {value:30, label:"Goa"},
        {value:31, label:"Lakshadweep"},
        {value:32, label:"Kerala"},
        {value:33, label:"Tamil Nadu"},
        {value:34, label:"Puducherry"},
        {value:35, label:"Andaman and Nicobar Islands"},
        {value:36, label:"Telangana"},
        {value:37, label:"Andhra Pradesh"},
        {value:38, label:"Ladakh"},
        {value:97, label:"Other Territory"}
    ],

    

    

};




  
